<template>
  <div class="confirmOrderClass">
    <div class="CustomGrid">
      <DxDataGrid
        id="confirm-order-datagrid"
        :data-source="ImportedProductData"
        :show-borders="false"
        :ref="gridRefName"
        :width="100 + '%'"
        :showColumnLines="true"
        :wordWrapEnabled="true"
        :headerFilter="{ visible: false }"
        @toolbar-preparing="onToolbarPreparing"
        :onContentReady="onContentReady"
        :remote-operations="false"
      >
        <DxSearchPanel :visible="true" :width="240" placeholder="Search..." />
        <DxHeaderFilter :visible="true" />
        <DxPaging :page-size="8" />
        <DxPager
          :show-page-size-selector="true"
          :allowed-page-sizes="[5, 10, 20, 50]"
          :show-info="true"
        />
        <DxColumn
          data-field="ChannelName"
          caption="Channel Name"
          data-type="string"
          width="90"
          alignment="left"
          :fixed="true"
        />
        <DxColumn
          data-field="DMA_RecID"
          caption="DMA RecID"
          data-type="number"
          width="90"
          alignment="left"
          :fixed="true"
        />
        <DxColumn
          data-field="NielsenDistributionID"
          caption="Nielsen Distribution ID"
          data-type="number"
          width="90"
          alignment="left"
          :fixed="true"
        />
        <DxColumn
          data-field="CM_Medium_RecID"
          caption="CM Medium RecID"
          data-type="number"
          width="90"
          alignment="left"
          :fixed="true"
        />
        <template #ClearBtn>
          <DxButton
            icon="fas fa-filter"
            hint="Clear All Filters"
            styling-mode="contained"
            :elementAttr="{ id: 'ClearAllBtn' }"
            :ref="'ClearAllBtnRef'"
            @click="clearDataGridFilters()"
            :disabled="!isFiltered"
          />
        </template>
      </DxDataGrid>
      <DxLoadPanel
        :position="loaderPosition"
        :visible.sync="loaderVisible"
        :show-indicator="true"
        shading-color="rgba(0,0,0,0.4)"
      />
    </div>
  </div>
</template>
<script>
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxSearchPanel,
  DxPaging,
  DxPager,
} from "devextreme-vue/data-grid";
import { DxButton } from "devextreme-vue";
import { DxLoadPanel } from "devextreme-vue/load-panel";
export default {
  name: "DecommissionChannelGrid",
  components: {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxSearchPanel,
    DxPaging,
    DxPager,
    DxButton,
    DxLoadPanel,
  },
  data() {
    return {
      gridRefName: "ConfirmOrder",
      user: this.$auth.user.UserDetails,
      isFiltered: false,
      loaderVisible: false,
      loaderPosition: { of: ".confirmOrderClass" },
    };
  },
  props: {
    ImportedProductData: Array,
  },
  mounted: function () {},
  methods: {
    onContentReady(e) {
      if (e.component.getCombinedFilter() == undefined) {
        this.isFiltered = false;
      } else {
        this.isFiltered = true;
      }
    },
    clearDataGridFilters() {
      this.$refs[this.gridRefName].instance.clearFilter();
    },
    refreshDataGrid() {
      this.$refs[this.gridRefName].instance.refresh();
    },
    ExportDataGrid() {
      this.$refs[this.gridRefName].instance.exportToExcel(false);
    },
    onToolbarPreparing: function (e) {
      var toolbarItems = e.toolbarOptions.items;
      for (var i = 0; i < e.toolbarOptions.items.length; i++) {
        if (e.toolbarOptions.items[i].name == "searchPanel") {
          e.toolbarOptions.items[i].location = "before";
        }
      }
      var customButtons = [
        {
          location: "before",
          template: "ClearBtn",
        },
        {
          location: "before",
          widget: "dxButton",
          options: {
            hint: "Export to Excel",
            icon: "fad fa-file-excel",
            onClick: this.ExportDataGrid.bind(this),
            elementAttr: { id: "ExcelBtn" },
          },
        },
        {
          location: "before",
          widget: "dxButton",
          options: {
            hint: "Refresh Grid",
            icon: "fad fa-sync",
            onClick: this.refreshDataGrid.bind(this),
            elementAttr: { id: "RefreshBtn" },
          },
        },
      ];
      toolbarItems.push(...customButtons);
      for (var i = 0; i < e.toolbarOptions.items.length; i++) {
        if (
          e.toolbarOptions.items[i].name == "saveButton" ||
          e.toolbarOptions.items[i].name == "addRowButton" ||
          e.toolbarOptions.items[i].name == "revertButton"
        ) {
          e.toolbarOptions.items[i].visible = false;
        }

        if (e.toolbarOptions.items[i].name == "searchPanel") {
          e.toolbarOptions.items[i].location = "before";
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.CustomGrid{
  padding: 0 20px;
}
</style>